export default "__VITE_ASSET__DpHN6Vyr__"